module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week/"},"frontmatter":{"title":"Just in: small batch of Jamaican Blue Mountain in store next week"}}}]}},"pathContext":{"tag":"green beans"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-green-beans.json
// module id = 362
// module chunks = 119922189093306